<div class="row" *ngIf="loading">
    <div class="col-sm-12 col-md-12 mt-4 d-flex justify-content-center align-items-center "
        *ngFor="let item of items; let i = index;">
        <div class="card article-list-card">
            <div class="card-body">
                <div class="col-md-10 col-sm-8 col-8"><!---->
                    <a class="ab-article-subject loader"><!----><!---->
                        <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </span></a>
                    <!-- <a class="ab-article-fasttrack loader">
                        <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </span></a> -->
                </div>

                <div class="row">
                    <div class="col-sm-10 col-md-10 card-content-div">
                        <div class="row">
                            <div class="col-sm-3 col-md-3">
                                <span>
                                    <img class="card-img-top loader" tabindex="0">

                                </span>
                                <span class="d-flex justify-content image-footer dwnld-count">
                                    <span class="d-flex justify-content image-footer-span">
                                        <span class="image-footer-span-innre loader mr-2">
                                            &nbsp;&nbsp;&nbsp;&nbsp;
                                        </span>
                                        <span tabindex="0" class="loader">
                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        </span>
                                    </span>
                                    <span class="d-flex justify-content image-footer-span-end">
                                        <span class="image-footer-span-innre loader mr-2">
                                            &nbsp;&nbsp;&nbsp;&nbsp;
                                        </span>
                                        <span tabindex="0" class="loader">
                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        </span>

                                    </span>

                                </span>
                            </div>
                            <div class="col-sm-8 col-md-8">
                                <h5 class="article-title loader">
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                </h5>
                                <h5 class="article-title loader">
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                </h5>

                                <div class="mb-1">
                                    <div class="">
                                        <span class="badge badge-primary badge-left p-2 loader"> <span
                                                class="issue-label ">
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                            </span><span
                                                class="issue-title">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></span>
                                    </div>

                                </div>
                                <div [ngStyle]="{'max-height': 'none' }" #authorDiv class="mb-2">
                                    <span class='activeSemicolumn loader' *ngFor="let authors of item;"
                                        tabindex="0">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                </div>
                                <button tabindex="0" class="authorButton mb-2 loader">
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;

                                </button>
                                <p tabindex="0" class="pt-1 mb-1 loader">
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                </p>
                                <p class="pt-1">
                                    <span class="loader">

                                    </span>
                                    <b tabindex="0" class="loader mr-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </b>
                                    <a
                                        class="link loader">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</a>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-2 col-md-2 mt-2 ">
                        <div style="margin-left:5px;">
                            <div class="open-access-logo loader"></div>

                            <p>
                                <span tabindex="0" class="colour-label loader">
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                <b tabindex="0">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</b>
                            </p>
                            <p>
                                <span tabindex="0"
                                    class="colour-label loader">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                <b tabindex="0">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</b>
                            </p>
                            <p>
                                <span tabindex="0"
                                    class="colour-label loader">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                <a style="cursor:pointer;">
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </a>
                            </p>
                            <a role="link" class="form-control article-view-btn loader">

                                <span class="ml-1">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                            </a>

                        </div>
                    </div>
                </div>
            </div>
            <div class="card-footer rvh-article-list-footer text-muted p-2 pt-3 pb-3">
                <div class="row ">
                    <div class="col-sm-6 col-md-6 pl-4">
                        <span class="colour-label loader"
                            tabindex="0">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </span><span class="pub-date loader"
                            tabindex="0">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                    </div>
                    <div class="col-sm-6 col-md-6 d-flex align-items-center colour-label" tabindex="0">
                        <b class="loader">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </b>
                        <span class="abstract-icon loader">

                        </span>
                    </div>
                </div>
                <div class="p-3 pb-0 rvh-article-abstract loader" tabindex="0">
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</div>
            </div>
        </div>
    </div>


</div>
<div class="row" *ngIf="!loading  ">

    <div class="col-sm-12 col-md-12 mt-4 d-flex justify-content-center align-items-center"
        *ngFor="let article of articleList; let i = index">
        <div class="card article-list-card">
            <div class="card-body">
                <div class="col-md-10 col-sm-8 col-8 article-subject"><!---->
                    <span *ngIf="article.subject_heading" class="ab-article-subject"
                        title="{{article.subject_heading}}"><!----><!---->
                        <span>{{article.subject_heading}} </span>
                    </span>
                    <span class="ab-article-fasttrack" *ngIf="fasttrack === true" title="Fast track Articles">
                        <span>Fast track Articles </span></span>
                </div>

                <div class="row">
                    <div class="col-sm-12 col-md-9 col-lg-9 card-content-div">
                        <div class="row">
                            <div class="col-sm-5 col-md-4 col-lg-4">
                                <span>
                                    <a [routerLink]="['/articles/'+article.volume+'/'+article.issue+'/'+article.article_id]"
                                        aria-label="Article Image">
                                        <img class="card-img-top" *ngIf="article.article_cover_image" tabindex="0"
                                            src="{{articleCoverImageUrl+'/'+article.journal_id+'/'+getArticleImageUrl(article)}}"
                                            [alt]="article.cover_alt_text">
                                    </a>
                                    <a [routerLink]="['/articles/'+article.volume+'/'+article.issue+'/'+article.article_id]"
                                        aria-label="Article Image">

                                        <img tabindex="0" *ngIf=" !article.article_cover_image && +article.volume <= 11"
                                            class="card-img-top rvh-article-default-cover"
                                            src="{{default_article_cover_image_upto_11}}"
                                            [alt]="'common.default_cover_image'|translate">
                                        <img tabindex="0" *ngIf=" !article.article_cover_image && +article.volume >11"
                                            class="card-img-top rvh-article-default-cover-green"
                                            src="{{default_article_cover_image_above_11}}"
                                            [alt]="'common.default_cover_image'|translate">
                                    </a>
                                </span>

                            </div>
                            <div class="col-sm-7 col-md-8 col-lg-8 article-sub" style="margin-top: 14px;">
                                <div class="card-content-div-section">
                                    <a class="article-title" *ngIf="fasttrack===false"
                                        [title]="getCleanTitle(article.article_title)"
                                        [innerHTML]="article.article_title | stripFootnote | highlightSearch : searchPipe"
                                        [routerLink]="[ '/articles/'+article.volume+'/'+article.issue+'/'+article.article_id]">
                                    </a>
                                    <a class="article-title" *ngIf="fasttrack===true"
                                        [title]="getCleanTitle(article.article_title)"
                                        [innerHTML]="article.article_title | stripFootnote | highlightSearch : searchPipe"
                                        [routerLink]="['/articles/'+'/fasttrack/'+article.volume+'/'+article.issue+'/'+article.article_id]">
                                    </a>

                                    <div *ngIf="article.issue_title" class="mb-1">
                                        <div class="theme-amber">
                                            <span class="badge badge-primary badge-left p-2"> <span class="issue-label">
                                                    Special Issue </span></span>
                                            <span class="issue-title">{{article.issue_title}}</span>
                                        </div>
                                    </div>
                                    <div [ngStyle]="{'max-height': isCollapsed[i] ? 'none' : '50px', 'overflow': 'hidden'}"
                                        #authorDiv class="mb-2 mt-2">
                                        <span class='activeSemicolumn' *ngFor="let authors of article.authors"
                                            tabindex="0"
                                            [innerHTML]="returnArticle(authors) | highlightSearch : searchPipe"></span>
                                    </div>
                                    <button tabindex="0" *ngIf="article.authors.length > 10" class="authorButton mb-2"
                                        (click)="showMoreAuthors(i)" (keyup.enter)="showMoreAuthors(i)"
                                        (keyup.space)="showMoreAuthors(i)" tabindex="0">
                                        {{ isCollapsed[i] ? 'Show less' : 'Show more' }}
                                        <fa-icon class="sort-icons" aria-hidden="true"
                                            [icon]="['fas', isCollapsed[i] ? 'chevron-up' : 'chevron-down']"
                                            class="pb-0"></fa-icon>
                                    </button>
                                    <!-- <p tabindex="0" class="pt-1 mb-1" style="color:black;">
                                    Pages {{article.page_start}} - {{article.page_end}},
                                    {{article.published_online}}, {{article.copyright_statement}}
                                              </p> -->
                                    <p tabindex="0" class="pt-1 mb-1 view-label article-doi" [innerHTML]="'Article '+article.article_id  | highlightSearch: searchPipe">
                                            </p>
                                </div>
                                <div class="pt-1">
                                    <span>
                                        <fa-icon class="glob-icon" aria-hidden="true"
                                            [icon]="['fas', 'earth-americas']"></fa-icon>
                                    </span>
                                    <span tabindex="0" class="article-id" style="color:#2a2a2a;">DOI : </span>
                                    <a class="link article-id doi-underline" target="_blank"
                                        href="https://doi.org/{{article.doi}}"
                                        [innerHTML]="article.doi | highlightSearch : searchPipe"
                                        title="https://doi.org/{{article.doi}}"></a>
                                </div>
                                <div class="pt-1">
                                    <span tabindex="0" class="article-id" style="color:#2a2a2a;">Keywords : </span>
                                    <span *ngFor="let keywords of article?.keywords" class="article-id activeSemicolumn" [innerHTML]="keywords | highlightSearch : searchPipe"></span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-3 col-lg-3 mt-2">
                        <div class="right-side-content" style="margin-left:5px;">
                            <!-- <div class="icon-box"  tabindex="0" (click)="addToFavourites(article)"> -->
                            <!-- <fa-icon *ngIf="!toggleFavourite(article,i)" (click)="addToFavourites(article,i)" class="iconcls favourite-icon black-icon" aria-hidden="true"
                                    [icon]="['far', 'star']"></fa-icon>
                                <fa-icon *ngIf="toggleFavourite(article,i)" (click)="addToFavourites(article,i)" class="iconcls favourite-icon black-icon" aria-hidden="true"
                                [icon]="['fas', 'star']"></fa-icon> -->
                            <!-- </div> -->
                            <img src='assets/logos/open_access_logo.webp' class="articlelist-open-access-logo"
                                [ngbTooltip]="'article_listing.open_access'|translate" [placement]="'left'"
                                alt="open access logo">
                            <div class="dropdown rvh-menu-label dropdown-share-div  dropdown-share{{i}}"
                                (mouseenter)="openDropdown('share',article,i)" (mouseleave)="closeDropdown('share',i)">
                                <a class="nav-link-primary heading" role="button" aria-haspopup="listbox"
                                    aria-label="share" aria-labelledby="dropdownMenuShare" data-bs-toggle="dropdown"
                                    aria-expanded="false" [ngbTooltip]="'article_listing.share'|translate"
                                    [placement]="'left'" [routerLink]="" title="Share"><fa-icon
                                        class="iconcls citation-icon black-icon" aria-hidden="true"
                                        [icon]="['fas', 'share-nodes']"></fa-icon>
                                </a>
                                <ul role="listbox" class="dropdown-menu rvh-share-menu-dropdown" aria-expanded="false"
                                    #dropdownMenuShare>
                                    <li>
                                        <span class="dropdown-item me-1" tabindex="0" title="Linkedin">
                                            <share-button button="linkedin" text="Linkedin" [showText]="true"
                                                description="Sharing the article link"
                                                [url]="sharedUrl+'/articles/'+article.volume+'/'+article.issue+'/'+article.article_id"></share-button>
                                        </span>
                                        <span class="dropdown-item me-1" tabindex="0" title="Tweet">
                                            <share-button button="twitter" text="Tweet" [showText]="true"
                                                [url]="sharedUrl+article.volume+'/'+article.issue+'/'+article.article_id"></share-button>
                                        </span>
                                        <span class="dropdown-item me-1" tabindex="0" title="Facebook">
                                            <share-button button="facebook" text="Facebook" [showText]="true"
                                                [url]="sharedUrl+article.volume+'/'+article.issue+'/'+article.article_id"></share-button>
                                        </span>
                                        <span class="dropdown-item me-1" tabindex="0" title="Email">
                                            <share-button button="email" text="Email" [showText]="true"
                                                description="Sharing the article link" [title]="titleShared"
                                                [url]="sharedUrl+article.volume+'/'+article.issue+'/'+article.article_id"></share-button>
                                        </span>
                                        <span class="dropdown-item me-1" tabindex="0" title="Copy link">
                                            <share-button button="copy" text="Copy Link" [showText]="true"
                                                [url]="sharedUrl+article.journal_id+'/articles/'+article.volume+'/'+article.issue+'/'+article.article_id"></share-button>
                                        </span>
                                    </li>
                                </ul>
                            </div>
                            <div class="dropdown rvh-menu-label dropdown-download-div  dropdown-download{{i}}"
                                (mouseleave)="closeDropdown('download',i)">
                                <a class="nav-link-primary heading" role="button" aria-haspopup="listbox"
                                    aria-labelledby="dropdownMenuDownload" data-bs-toggle="dropdown"
                                    aria-expanded="false" [ngbTooltip]="'download'" [placement]="'left'"
                                    aria-label="download" [routerLink]="" title="Download" (mouseenter)="openDropdown('download',article,i)">
                                    <fa-icon class="iconcls citation-icon black-icon" aria-hidden="true"
                                        [icon]="['fas', 'cloud-arrow-down']"></fa-icon>
                                </a>
                                <ul role="listbox" class="dropdown-menu rvh-article-download-button"
                                    aria-expanded="false" #dropdownMenuDownload>
                                    <!-- <li>
                                        <a *ngIf="!disableBtnPdf" class="dropdown-item" tabindex="0"
                                            (click)="downloadPdf('pdf',article)"
                                            (keyup.enter)="downloadPdf('pdf',article)"
                                            (keyup.space)="downloadPdf('pdf',article)" id="liveToastBtn"
                                            title="PDF Download">
                                            <button class="image-icon-button me-1 mt-1" tabindex="0">
                                                <img class="download-icon-image"
                                                    src="assets/images/pdf_download_image.png" [alt]="'download pdf'">
                                            </button>
                                            PDF Download
                                        </a>
                                    </li>
                                    <li>
                                        <a *ngIf="!disableBtnXml" class="dropdown-item" tabindex="0"
                                            (click)="downloadPdf('xml',article)"
                                            (keyup.enter)="downloadPdf('xml',article)"
                                            (keyup.space)="downloadPdf('xml',article)" id="liveToastBtn"
                                            title="XML Download">
                                            <button class="image-icon-button me-1 mt-1" tabindex="0">
                                                <img class="download-icon-image"
                                                    src="assets/images/xml_download_image.png" [alt]="'download xml'">
                                            </button>
                                            XML Download
                                        </a>
                                    </li> -->
                                    <li role="listitem">
                                        <a *ngIf="!disableBtnPdf" class="dropdown-item" tabindex="0" role="button"
                                            (click)="downloadPdf('pdf',article)" (keyup.enter)="downloadPdf('pdf',article)"
                                            (keyup.space)="downloadPdf('pdf',article)" title="PDF Download">
                                            <div class="download-container">
                                                <div class="icon-container">
                                                    <fa-icon [icon]="['fas', 'download']" class="iconcls"></fa-icon>
                                                </div>
                                                <div class="text-container">PDF</div>
                                            </div>
                                        </a>
                                    </li>
                                    <li role="listitem">
                                        <a *ngIf="!disableBtnXml" class="dropdown-item" tabindex="0" role="button"
                                            (click)="downloadPdf('xml',article)" (keyup.enter)="downloadPdf('xml',article)"
                                            (keyup.space)="downloadPdf('xml',article)" title="XML Download">
                                            <div class="download-container">
                                                <div class="icon-container">
                                                    <fa-icon [icon]="['fas', 'download']" class="iconcls"></fa-icon>
                                                </div>
                                                <div class="text-container">XML</div>
                                            </div>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                            <p class="mt-2">
                                <a style="cursor:pointer;" class="journal-title" [routerLink]="['']"
                                    title=" {{article.journal_title}}">
                                    {{article.journal_title}} </a>
                            </p>
                            <p>
                                <span tabindex="0" class="colour-label">{{'article_listing.volume' |
                                    translate}}</span> : <span class="article-doi" tabindex="0"> {{article.volume}}
                                </span>
                            </p>
                            <p *ngIf="article.issue!=='non-issue'">
                                <span tabindex="0" class="colour-label pb-3">{{'article_listing.issue' |
                                    translate}}</span> : <span class="article-doi" tabindex="0">
                                    {{changeIssue(article.issue)}} </span>
                            </p>
                            <span class="d-flex justify-content image-footer dwnld-count">
                                <span class="d-flex justify-content image-footer-span">
                                    <span class="image-footer-span-innre"
                                        [ngbTooltip]="'article_listing.download_count'|translate"
                                        [placement]="'bottom'">
                                        <fa-icon class="iconcls" aria-hidden="true" [icon]="['fas', 'download']">
                                        </fa-icon>
                                    </span>
                                    <span tabindex="0"
                                        [attr.aria-label]="('article_listing.download_count'|translate)+ article.download_count">
                                        {{article.download_count}}
                                    </span>
                                    
                                </span>
                                <span class="d-flex justify-content image-footer-span-end">
                                    <span class="image-footer-span-innre"
                                        [ngbTooltip]="'article_listing.view_count'|translate" [placement]="'bottom'">
                                        <fa-icon class="iconcls" aria-hidden="true" [icon]="['fas', 'eye']">
                                        </fa-icon>

                                    </span>
                                    <span tabindex="0"
                                        [attr.aria-label]="('article_listing.view_count'|translate)+ article.view_count">
                                        {{article.view_count}}
                                    </span>

                                </span>

                            </span>
                            <div class="row ">
                                <div class="col pl-3 d-xs-block d-sm-block d-md-none  d-lg-none  d-xl-none d-xxl-none">
                                    <span class="article-id" tabindex="0">{{'article_listing.published' | translate}} :
                                    </span><span class="article-doi" tabindex="0">{{article.published_online}}</span>
                                </div>
                            </div>
                            <div class="d-sm-flex justify-content-sm-end justify-content-md-start d-xs-flex justify-content-xs-end ">
                                <a role="link" class="form-control article-view-btn mt-1 margin-zero-mobile"
                                    [routerLink]="['/articles/'+article.volume+'/'+article.issue+'/'+article.article_id]"
                                    [ngbTooltip]="'article_listing.article_view_page'|translate" [placement]="'bottom'">
                                    <fa-icon class="viewiconcls" aria-hidden="true" [icon]="['fas', 'eye']"
                                        aria-label="View Article">
                                    </fa-icon>
                                    <span class="ml-1 view-label">{{'article_listing.articles_view' |
                                        translate}}</span>
                                </a>
                            </div>
                            <a role="link" class="form-control article-view-btn-only" aria-label="View Article"
                                [routerLink]="['/articles/'+article.volume+'/'+article.issue+'/'+article.article_id]"
                                [ngbTooltip]="'article_listing.article_view_page'|translate" [placement]="'bottom'"
                                title="View article">
                                <fa-icon class="viewiconcls" aria-hidden="true" [icon]="['fas', 'eye']">
                                </fa-icon>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card-footer rvh-article-list-footer text-muted p-2 pt-3 pb-3">
                <div class="row ">
                    <div
                        class="col-sm-6 col-md-6 pl-4 d-xs-none d-sm-none d-md-block d-lg-block d-xl-block d-xxl-block">
                        <span class="article-id" tabindex="0">{{'article_listing.published' | translate}} :
                        </span><span class="article-doi" tabindex="0">{{article.published_online}}</span>
                    </div>
                    <div class="col-sm-6 col-md-6 d-flex align-items-center abstract-label" (click)="abstractClick(i)"
                        (keyup.enter)="abstractClick(i)" (keyup.space)="abstractClick(i)" tabindex="0">
                        <span class="abstract-label" style="cursor:pointer;"> {{'article_listing.abstract' | translate}}
                        </span>
                        <span class="abstract-icon">
                            <fa-icon class="iconcls " aria-hidden="true"
                                [icon]="['fas',isAngleDown[i] ? 'angle-up' : 'angle-down']">
                            </fa-icon>
                        </span>
                    </div>
                </div>
                <div class="p-3 pb-0 rvh-article-abstract" *ngIf="abstract[i]" tabindex="0"
                    [innerHTML]="article.abstract"></div>
            </div>
        </div>
    </div>
</div>
<div class="primary" *ngIf="articleList.length === 0 && !loading">
    <!-- {{'article_listing.no_articles_found' | translate}} -->
    <div style="display: flex; flex-direction: column; align-items: center; padding-bottom: 5px;">
        <img class="no-data-found-img" src="assets/images/not_found_img/no_data_1.webp" alt="">
        <h2 class="card-title text-head-size">{{'article_listing.no_articles_found' | translate}}</h2>
    </div>
</div>
<app-toaster-downloading [downloading]="downloading" [downloadingData]="downloadingData" [disableBtnPdf]="disableBtnPdf"
    [downloadCount]="downloadCount" (downloadcount)="downloadcount($event)" [pdfnotexist]="pdfExit"></app-toaster-downloading>